import { useMutation } from "@tanstack/react-query"
import { post } from "../post"
import { UsePostMutationQueryOptions } from "../types"
import type * as Api from "../../@client/api"
import { useHandleAsyncSafely } from "./use-handle-async-safely"

export function usePostMutation<ActionName extends keyof Api.POST>(
  url: ActionName,
  options?: UsePostMutationQueryOptions<ActionName>,
  requestInit?: RequestInit
) {
  const handleAsyncSafely = useHandleAsyncSafely<Api.Output[ActionName]>()

  return useMutation({
    ...options,
    mutationKey: [url, requestInit],
    mutationFn: (input) =>
      handleAsyncSafely(
        () => post<ActionName>(url, input, requestInit),
        options
      ),
  })
}
